import { css } from 'linaria';
import { styled } from 'linaria/react';
import { breakpoints } from 'media';

export const ServiceCenterContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 32px;
	width: 100%;
	height: 100%;
	${breakpoints.from.desktop} {
		margin-bottom: 120px;
	}
`;

export const HeaderBlock = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	${breakpoints.only.mobile} {
		flex-direction: column;
		align-items: flex-start;
		gap: 12px;
	}
`;

export const hintStyles = css`
	display: flex;
	align-items: center;
	gap: 4px;
`;

export const FlexColumnBlock = styled.div<{ gap: number; marginTop: number }>`
	display: flex;
	flex-direction: column;
	gap: ${({ gap = 24 }) => `${gap}px`};
	margin-top: ${({ marginTop = 0 }) => `${marginTop}px`};
`;

export const PhoneLink = styled.a`
	color: #ffffff;
	font-size: 15px;
	font-style: normal;
	font-weight: 400;
	line-height: 18px;
	letter-spacing: 0.2px;
`;

export const HintTextContent = styled.div`
	width: 250px;
	color: #ffffff;
`;

export const hintBtnStyles = css`
	font-weight: 400 !important;
	font-size: 17px !important;
	${breakpoints.only.mobile} {
		padding: 0 !important;
	}
`;
export const breadcrumbsStyles = css`
	margin: 24px 0;
`;
